/**
 * Converts a `FileMetadata[]` image attachment list into the plain
 * `LightboxImage[]` array the lightbox carousel expects.
 *
 * Called by `MediaCard` once per render so all `ImageAttachmentCard` children
 * share the same ordered array — enabling prev/next navigation across images
 * in the same message.
 */
const toLightboxImages = imageAttachments => imageAttachments.map(fileMetadata => ({
  src: fileMetadata.url,
  alt: fileMetadata.displayName
}));
export default toLightboxImages;